export const parseWidthValue = (value) => {
  const number = Number.parseFloat(value)
  const unit = value.replace(number, '')

  return {
    number: number || 0,
    unit: unit || 'px',
  }
}
